export default __webpack_public_path__ + "static/media/avatar.4fdeb54e.svg";